import React, { Fragment, useEffect, useMemo } from "react";
import { useState } from "react";
import {
  Backdrop,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider, Grid,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Paper,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import {
  MoreVertOutlined,
  MoreVertRounded, RestoreSharp, SettingsBackupRestoreRounded,
  SubdirectoryArrowRightOutlined
} from "@mui/icons-material";
import axios from "axios";
import { useHistory } from "react-router-dom";
import cookie from "react-cookies";
import BuyerSearchBar from "./BuyerSearchBar";
import {
  EXPIRE_DATE_MAX_YEAR,
  RECEIVE_ALL_CHECKED_COLOR,
  RECEIVE_PARTIAL_CHECKED_COLOR,
  RECEIVER_COOKIE_KEY
} from "../constant";
import {
  changeImageURL, changeStockValue,
  getMultilineTextToHtml, getRackCodeByCenterId,
  getRecvCenterName, getShopNameString,
  getWarehouseName
} from "../stringutils";
import moment from "moment";
import { useUserState } from "../UserContext";
import { FSBarcodeReader } from "./FSBarcodeReader";
import { useSnackbar } from "notistack";
import { useWarehouseState } from "../WarehouseContext";
import { Alert, Box, Button, Typography } from "@mui/material";
import styled from "@emotion/styled";
import { arrivalHistoryList, purchaseInfoForDialog } from "../common";
const tableMinHeight = "calc((100vh - 250px) / 2)";


const MessagePaper = styled(Paper)(({ theme }) => ({
  marginTop: theme.spacing(1),
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: tableMinHeight,
}));

const TableHeaderPaper = styled(Paper)(({ theme }) => ({
  paddingTop: theme.spacing(0),
  paddingBottom: theme.spacing(0),
  marginTop: theme.spacing(1),
}));

const clickableItem = {
  cursor: 'pointer',
}


export default function ArrivalView(props) {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const warehouseState = useWarehouseState()
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false)
  // const style = useStyles()
  const history = useHistory()
  // const [title, setTitle] = useState('')
  const [products, setProducts] = useState([])
  const [requesting, setRequesting] = useState(false)
  const [showOverlayProgress, setShowOverlayProgress] = useState(false)
  const [purchaseList, setPurchaseList] = useState([[]])
  const [purchaseMessage, setPurchaseMessage] = useState("")

  const [newProductList, setNewProductList] = useState([])
  const [productInfoList, setProductInfoList] = useState([])

  // const [selectedPurchase, setSelectedPurchase] = useState(null)

  const [arrivalList, setArrivalList] = useState([])
  const [arrivalMessage, setArrivalMessage] = useState("")

  // const [snackbar, setSnackbar] = useState({
  //   open : false,
  //   message : '',
  // })

  const userState = useUserState()



  const [imageShow, setImageShow] = useState({
    open: false,
    url: '',
    title: ''
  })


  const [dialog, setDialog] = useState({
    open: false,
    title: '',
    message: '',
    errorMessage: '',
  })

  const [checkDialog, setCheckDialog] = useState({
    open: false,
    purchase: null,
    cart: null,
    history: [],
    recvCount: 0,
    recvCountError: false,
    recvCountHelperText: ''
  })

  const [arrivalHistoryDialog, setArrivalHistoryDialog] = useState({
    open: false,
    history: [],
    purchase: null,
  })

  const [expireDateDialog, setExpireDateDialog] = useState({
    open: false,
    years: [],
    purchase: null,
    recvCount: 0,
    cart: null,
  })

  const changeRecvCount = (event) => {
    console.log("changeRecvCount " + event.target.value)

    let value = parseInt(event.target.value)
    console.log("changeRecvCount " + value)

    let update = {
      recvCount: value
    }
    // setRecvCount(value)
    if (isNaN(value)) {

      // setRecvCountError(true)
      // setRecvCountHelperText("입고갯수가 유효하지 않습니다")
      setCheckDialog({
        ...checkDialog,
        recvCount: value,
        recvCountError: true,
        recvCountHelperText: "입고갯수가 유효하지 않습니다"
      })
    } else if (value > checkDialog.purchase.buy_quantity) {
      // setEnableWrongCheck(false)
      // setRecvCountError(true)
      // setRecvCountHelperText("입고갯수는 총 갯수를 넘을수 없습니다.")
      setCheckDialog({
        ...checkDialog,
        recvCount: value,
        recvCountError: true,
        recvCountHelperText: "입고갯수는 총 갯수를 넘을수 없습니다."
      })
    } else if (value <= 0) {
      // setEnableWrongCheck(false)
      // setRecvCountError(true)
      // setRecvCountHelperText("입고갯수는 1보다 커야 합니다.")
      setCheckDialog({
        ...checkDialog,
        recvCount: value,
        recvCountError: true,
        recvCountHelperText: "입고갯수는 1보다 커야 합니다."
      })
    } else {
      setCheckDialog({
        ...checkDialog,
        recvCount: value,
        recvCountError: false,
        recvCountHelperText: ""
      })

    }
  }


  // const isCartReceived = (cart_no) => {
  //   for (let cart of arrivalList) {
  //     if (cart && cart.length > 0) {
  //       if (cart[0].cart_no === cart.cart_no) {
  //         for(let purchase of cart){
  //           if(purchase.recv_state !== 'C'){
  //             return false;
  //           }
  //         }
  //
  //         return true
  //       }
  //     }
  //   }
  //
  //   return false
  // }


  const sortWithCart = (carts, purchase) => {
    for (let cart of carts) {
      if (cart && cart.length > 0) {
        if (cart[0].cart_no === purchase.cart_no) {
          if (purchase.is_related === 'N') {
            cart.unshift(purchase)
          } else {
            cart.push(purchase)
          }

          return carts
        }
      }
    }

    return [...carts, [purchase]]
  }

  const requestCancelArrival = (purchase) => {
    console.log('requestCancelArrival ', purchase)


    setRequesting(true)
    setPurchaseMessage("")
    setArrivalMessage("")
    setOpenDeleteDialog(false)

    console.log('requestCancelArrival', purchase)

    axios.post(`${process.env.REACT_APP_API_HOST}/arrival/cancel`, {
      params: {
        token: cookie.load(RECEIVER_COOKIE_KEY)
      },
      center_id: purchase.recv_center,
      cart_no: purchase.cart_no,
      purchase_id: purchase.purchase_id,
      ff_yn: purchase.ff_yn,
      store_no: purchase.store_no,
      warehouse: purchase.warehouse
    }).then((resp) => {

      if (resp.status === 200 && resp.data != null && resp.data['code'] === 200) {
        // history.replace('/', {snackbar: '입고 취소가 완료되었습니다.'})


        // console.log('arrivals ', arrivalList)
        // console.log('purchases ', purchaseList)
        // purchase.recv_quantity = 0
        // purchase.recv_yn = 'N'
        // const updated = sortWithCart(purchaseList, purchase)
        //
        // setPurchaseList(updated)
        //
        // let newArrivalList = []
        //
        // for(let p of arrivalList){
        //   let results = p.filter((row) => row.purchase_id !== purchase.purchase_id)
        //   if(results.length > 0){
        //     newArrivalList.push(results)
        //   }
        // }
        // // let filtered = arrivalList.filter((p) => p.filter((row) => row.purchase_id !== purchase.purchase_id).length !== 0)
        // if(newArrivalList.length === 0){
        //   setArrivalMessage("입고된 상품이 없습니다.")
        // }
        // setArrivalList(newArrivalList)
        //
        // console.log('new arrivals ', newArrivalList)
        // console.log('new purchases ', updated)

        setUI(products)
        enqueueSnackbar(`"${purchase.product_name}" - 입고가 취소 되었습니다.`, { variant: 'success' })
      } else if (resp.status === 200 && resp.data != null && resp.data['code'] === 0) {
        history.replace('/signin')
      } else if (resp.status === 200 && resp.data != null && resp.data['code'] === 499) {
        cookie.remove(RECEIVER_COOKIE_KEY)
        history.replace('/not-permitted')
      } else if (resp.status === 200 && resp.data != null && resp.data['code'] === 461) {
        setDialog({
          open: true,
          message: "정상적인 경로로 입고 처리 되지 않아 취소가 불가능합니다.",
          errorMessage: '에러코드 ' + resp.data != null ? resp.data['code'] : resp.status
        })
      } else {
        setDialog({
          open: true,
          message: "입고 취소를 실패 하였습니다.",
          errorMessage: '에러코드 ' + resp.data != null ? resp.data['code'] : resp.status
        })
      }

      setRequesting(false)

    }).catch((e) => {

      setDialog({
        open: true,
        message: "입고 취소를 실패 하였습니다.",
        errorMessage:
          e.response != null && e.response.status > 0 ?
            "오류코드 : " + e.response.status
            : "네트워크 환경을 확인 해 주세요"
      })

      setRequesting(false)
    })
  }

  const getArrivalHistoryAndShowDialog = (purchase, cart, withEdit) => {
    setShowOverlayProgress(true)
    axios.get(`${process.env.REACT_APP_API_HOST}/arrival/history`, {
      params: {
        token: cookie.load(RECEIVER_COOKIE_KEY),
        purchase_id: purchase.purchase_id,
      },

    }).then((resp) => {

      if (resp.status === 200 && resp.data != null && resp.data['code'] === 200) {
        if (withEdit) {
          setCheckDialog({
            ...checkDialog,
            open: true,
            purchase: purchase,
            cart: cart,
            recvCount: purchase.buy_quantity,
            recvCountError: false,
            recvCountHelperText: '',
            history: resp.data.results
          })
        } else {
          setArrivalHistoryDialog({
            open: true,
            history: resp.data.results,
            purchase: purchase
          })
        }

        setShowOverlayProgress(false)
        return
      } else if (resp.status === 200 && resp.data != null && resp.data['code'] === 0) {
        history.replace('/signin')
      } else if (resp.status === 200 && resp.data != null && resp.data['code'] === 451) {
        setDialog({
          open: true,
          title: "오류발생",
          message: "입고 처리 권한이 없는 계정입니다.",
          errorMessage: ''
        })
      } else if (resp.status === 200 && resp.data != null && resp.data['code'] === 499) {
        cookie.remove(RECEIVER_COOKIE_KEY)
        history.replace('/not-permitted')
      } else {
        setDialog({
          open: true,
          title: "오류발생",
          message: "서버와의 통신에 실패 하였습니다.",
          errorMessage: '에러코드 ' + resp.data != null ? resp.data['code'] : resp.status
        })
      }

      setShowOverlayProgress(false)

    }).catch((e) => {
      console.log('error ' + e)
      setDialog({
        open: true,
        title: "오류발생",
        message: "서버와의 통신에 실패 하였습니다.",
        errorMessage:
          e.response != null && e.response.status > 0 ?
            "오류코드 : " + e.response.status
            : "네트워크 환경을 확인 해 주세요"
      })

      setShowOverlayProgress(false)
    })
  }

  const cancelCheck = (purchase) => {

    console.log('cancelCheck ', purchase)

    setRequesting(true)
    setPurchaseMessage("")
    setArrivalMessage("")
    let scrollY = window.scrollY

    axios.post(`${process.env.REACT_APP_API_HOST}/arrival/cancel_check`, {
      params: {
        token: cookie.load(RECEIVER_COOKIE_KEY)
      },
      purchase_id: purchase.purchase_id,
      center_id: props.centerId,
      ff_yn: purchase.ff_yn,
      store_no: purchase.store_no,
      warehouse: purchase.warehouse,
      product_fs_id : purchase.product_fs_id,
    }).then((resp) => {

      if (resp.status === 200 && resp.data != null && resp.data['code'] === 200) {

        purchase.recv_state = 'O'
        purchase.recv_quantity = 0
        setRequesting(false)
        console.log('lastScroll', scrollY)
        window.scrollTo(0, scrollY)
        return
      } else if (resp.status === 200 && resp.data != null && resp.data['code'] === 0) {
        history.replace('/signin')
      } else if (resp.status === 200 && resp.data != null && resp.data['code'] === 451) {
        setDialog({
          open: true,
          title: "입고 처리 실패",
          message: "입고 처리 권한이 없는 계정입니다.",
          errorMessage: ''
        })
      } else if (resp.status === 200 && resp.data != null && resp.data['code'] === 461) {
        setDialog({
          open: true,
          title: "입고 처리 실패",
          message: "이미 입고 처리된 된 상품입니다.(입고 예정 상품을 다시 불러옵니다)",
          errorMessage: ''
        })
        setUI(products)
      } else if (resp.status === 200 && resp.data != null && resp.data['code'] === 499) {
        cookie.remove(RECEIVER_COOKIE_KEY)
        history.replace('/not-permitted')
      } else {
        setDialog({
          open: true,
          title: "오류발생",
          message: "입고 처리에 실패 하였습니다.",
          errorMessage: '에러코드 ' + resp.data != null ? resp.data['code'] : resp.status
        })
      }

      setRequesting(false)

    }).catch((e) => {
      console.log('error ' + e)
      setDialog({
        open: true,
        title: "오류발생",
        message: "입고 처리에 실패 하였습니다.",
        errorMessage:
          e.response != null && e.response.status > 0 ?
            "오류코드 : " + e.response.status
            : "네트워크 환경을 확인 해 주세요"
      })

      setRequesting(false)
    })


  }

  const showExpireDateDialog = (purchase, recv_count, cart) => {
    if (purchase.recv_state === 'C' && purchase.recv_quantity === purchase.buy_quantity && recv_count === purchase.buy_quantity) {
      console.log('already checked')
      return
    }
    const years = []
    for (let i = 0; i < EXPIRE_DATE_MAX_YEAR; i++) {
      let yearDate = moment().add(i, 'years').toDate();
      // console.log(years)
      years.push(yearDate)
    }
    // new Date().getMonth()
    setExpireDateDialog({
      open: true,
      years: years,
      purchase: purchase,
      recvCount: recv_count,
      cart: cart
    })
  }

  const checkArrival = async (purchase, recv_count, cart, expireDate) => {

    // console.log('chaeckArrival, ', moment(expireDate).format('YYYY/MM/DD HH:mm'))
    //  return
    if (recv_count === 0) {
      console.log('invalid receive count')
      return
    }
    if (purchase.recv_state === 'C' && purchase.recv_quantity === purchase.buy_quantity && recv_count === purchase.buy_quantity) {
      console.log('already checked')
      return
    }

    console.log('[JW] checkArrival ', purchase)
    setExpireDateDialog({ ...expireDateDialog, open: false })
    setCheckDialog({ ...checkDialog, open: false })
    setRequesting(true)
    setPurchaseMessage("")
    setArrivalMessage("")

    let scrollY = window.scrollY

    console.log('checkArrival -> ', process.env.REACT_APP_API_HOST);
    console.log('checkArrival -> ', purchase);

    try {
      const stockResp = await axios.get(`${process.env.REACT_APP_API_HOST}/product/stock_info`, {
        params: {
          token: cookie.load(RECEIVER_COOKIE_KEY),
          id_fs: purchase.product_fs_id,
          center_id: props.centerId,
        },
        timeout: 15000,
      })

      if (stockResp.status === 200 && stockResp.data != null && stockResp.data['code'] === 200) {
        const { center_stock, naver_stock, coupang_stock } = stockResp.data.results
        const allEmpty = !center_stock && !naver_stock && !coupang_stock

        if (allEmpty) {
          const expireListResp = await axios.get(`${process.env.REACT_APP_API_HOST}/product/expire_date_list`, {
            params: {
              token: cookie.load(RECEIVER_COOKIE_KEY),
              id_fs: purchase.product_fs_id,
              center_id: props.centerId,
            },
            timeout: 15000,
          })

          if (expireListResp.status === 200 && expireListResp.data != null && expireListResp.data['code'] === 200) {
            const expireDates = (expireListResp.data.results ?? [])
              .map(r => r.expire_date)
              .filter(d => d != null)

            for (const expDate of expireDates) {
              await axios.put(`${process.env.REACT_APP_API_HOST}/product/expire_date_delete`, {
                params: { token: cookie.load(RECEIVER_COOKIE_KEY) },
                idfs: purchase.product_fs_id,
                center_id: props.centerId,
                expire_date: moment(new Date(expDate)).format('YYYY/MM/DD HH:mm'),
              })
            }
          }
        }
      } else {
        enqueueSnackbar("유통기한 조회를 실패하였습니다.", { variant: 'warning' })
      }
    } catch (e) {
      console.log('stock_info error', e)
      enqueueSnackbar("유통기한 조회를 실패하였습니다.", { variant: 'warning' })
    }

    try {
      const resp = await axios.post(`${process.env.REACT_APP_API_HOST}/arrival/check`, {
        params: {
          token: cookie.load(RECEIVER_COOKIE_KEY)
        },
        purchase_id: purchase.purchase_id,
        product_fs_id: purchase.product_fs_id,
        cart_no: purchase.cart_no,
        center_id: props.centerId,
        recv_quantity: recv_count,
        expire_date: expireDate ? moment(expireDate).format('YYYY/MM/DD HH:mm') : null,
        ff_yn: purchase.ff_yn,
        store_no: purchase.store_no,
        warehouse: purchase.warehouse
      })

      if (resp.status === 200 && resp.data != null && resp.data['code'] === 200) {

        purchase.recv_state = 'C'
        purchase.recv_quantity = recv_count
        purchase.last_event_user_name = userState.data ? userState.data.results.name : ""
        setRequesting(false)
        console.log('lastScroll', scrollY)
        window.scrollTo(0, scrollY)
        return
      } else if (resp.status === 200 && resp.data != null && resp.data['code'] === 201) {
        // requestPurchase(props.products)
        if (cart.length > 1) {
          enqueueSnackbar(`"${cart[0].product_name}" 외 ${cart.length - 1} 개 - 입고 처리가 완료되었습니다.`, { variant: 'success' })
        } else {
          enqueueSnackbar(`"${purchase.product_name}" - 입고 처리가 완료되었습니다.`, { variant: 'success' })
        }
        setUI(products)
      } else if (resp.status === 200 && resp.data != null && resp.data['code'] === 0) {
        history.replace('/signin')
      } else if (resp.status === 200 && resp.data != null && resp.data['code'] === 451) {
        setDialog({
          open: true,
          title: "입고 처리 실패",
          message: "입고 처리 권한이 없는 계정입니다.",
          errorMessage: ''
        })
      } else if (resp.status === 200 && resp.data != null && resp.data['code'] === 461) {
        setDialog({
          open: true,
          title: "입고 처리 실패",
          message: "이미 입고 처리된 된 상품입니다.(입고 예정 상품을 다시 불러옵니다)",
          errorMessage: ''
        })
        setUI(products)
      } else if (resp.status === 200 && resp.data != null && resp.data['code'] === 499) {
        cookie.remove(RECEIVER_COOKIE_KEY)
        history.replace('/not-permitted')
      } else {
        setDialog({
          open: true,
          title: "오류발생",
          message: "입고 처리에 실패 하였습니다.",
          errorMessage: '에러코드 ' + resp.data != null ? resp.data['code'] : resp.status
        })
      }

      setRequesting(false)

    } catch (e) {
      console.log('error ' + e)
      setDialog({
        open: true,
        title: "오류발생",
        message: "입고 처리에 실패 하였습니다.",
        errorMessage:
          e.response != null && e.response.status > 0 ?
            "오류코드 : " + e.response.status
            : "네트워크 환경을 확인 해 주세요"
      })

      setRequesting(false)
    }

  }


  //  const postArrival = (purchase) => {
  //
  //   console.log('postArrival ', purchase)
  //
  //   setRequesting(true)
  //   setPurchaseMessage("")
  //   setArrivalMessage("")
  //
  //   setArrivalDialog({
  //     ...arrivalDialog,
  //     open : false
  //   })
  //
  //   axios.post(`${process.env.REACT_APP_API_HOST}/arrival`, {
  //     params : {
  //       token : cookie.load(RECEIVER_COOKIE_KEY)
  //     },
  //     recv_center_id : props.centerId,
  //     purchase_user_id : purchase.buyer_id,
  //     product_opt_code : purchase.product_opt_code,
  //     product_id : purchase.product_id,
  //     name_list : purchase.buyer_name_list,
  //     purchase_id : purchase.purchase_id,
  //     product_fs_id : purchase.product_fs_id,
  //     buy_quantity : purchase.buy_quantity,
  //     // recv_quantity : recvCount,
  //     recv_quantity : purchase.buy_quantity,
  //     arrival : true,
  //     wrong_id : purchase.wrong_id === undefined ? null : purchase.wrong_id,
  //     memo : memo,
  //     is_wrong_delivery : wrong
  //
  //   }).then((resp)=>{
  //
  //     if(resp.status === 200 && resp.data != null && resp.data['code'] === 200){
  //
  //       console.log('arrivals ', arrivalList)
  //       console.log('purchases ', purchaseList)
  //
  //       purchase.recv_yn = 'Y'
  //       purchase.recv_quantity = purchase.buy_quantity
  //       purchase.recv_date = new Date()
  //       purchase.receiver_name = userState.data.results.name
  //       purchase.recv_center = props.centerId
  //
  //       const updatedArrival = sortWithCart(arrivalList, purchase)
  //
  //       let newPurchaseList = []
  //
  //       for(let p of purchaseList){
  //         let results = p.filter((row) => row.purchase_id !== purchase.purchase_id)
  //         if(results.length > 0){
  //           newPurchaseList.push(results)
  //         }
  //       }
  //
  //       // let filtered = purchaseList.filter((p) => p.filter((row) => row.purchase_id !== purchase.purchase_id).length !== 0)
  //       if(newPurchaseList.length === 0){
  //         setPurchaseMessage("입고 예정인 상품이 없습니다.\n다음에 입고할 상품을 스캔하세요")
  //       }
  //
  //
  //       console.log('new arrivals ', updatedArrival)
  //       console.log('new purchases ', newPurchaseList)
  //
  //       setPurchaseList(newPurchaseList)
  //       setArrivalList(updatedArrival)
  //
  //
  //       setRequesting(false)
  //
  //       // setSnackbar({
  //       //   open: true,
  //       //   message: "입고 처리가 완료되었습니다."
  //       // })
  //
  //       enqueueSnackbar(`"${purchase.product_name}" - 입고 처리가 완료되었습니다.`, {variant : 'success'})
  //
  //     }else if(resp.status === 200 && resp.data != null && resp.data['code'] === 0) {
  //       history.replace('/signin')
  //     }else if(resp.status === 200 && resp.data != null && resp.data['code'] === 451){
  //       setDialog({
  //         open: true,
  //         title: "입고 처리 실패",
  //         message: "입고 처리 권한이 없는 계정입니다.",
  //         errorMessage: ''
  //       })
  //     }else if(resp.status === 200 && resp.data != null && resp.data['code'] === 499){
  //       cookie.remove(RECEIVER_COOKIE_KEY)
  //       history.replace('/not-permitted')
  //     }else{
  //       setDialog({
  //         open: true,
  //         title: "오류발생",
  //         message: "입고 처리에 실패 하였습니다.",
  //         errorMessage: '에러코드 ' + resp.data != null ? resp.data['code'] : resp.status
  //       })
  //     }
  //
  //     setRequesting(false)
  //
  //   }).catch((e) =>{
  //     console.log('error ' + e)
  //     setDialog({
  //       open: true,
  //       title: "오류발생",
  //       message: "입고 처리에 실패 하였습니다.",
  //       errorMessage:
  //         e.response != null && e.response.status > 0 ?
  //           "오류코드 : " + e.response.status
  //           : "네트워크 환경을 확인 해 주세요"
  //     })
  //
  //     setRequesting(false)
  //   })
  //
  //
  // }



  const parseDate = (str) => {
    if (!str) return 0
    return new Date(str.replace(' ', 'T')).getTime()
  }

  const requestPurchase = (ids) => {
    console.log('[JW] requestPurchase ', ids)
    // ids = [98, 4747, 3910]
    setRequesting(true)
    setPurchaseMessage("")
    setArrivalMessage("")
    setPurchaseList([])
    setArrivalList([])
    setNewProductList([])
    setProductInfoList([])

    axios.get(`${process.env.REACT_APP_API_HOST}/purchase/array-with-arrival?id=${ids.join(',')}&token=${cookie.load(RECEIVER_COOKIE_KEY)}&days_before=180`)
      .then((resp) => {
        console.log("resp ", resp.data)

        if (resp.status === 200 &&
          resp.data != null &&
          resp.data['code'] === 200) {

          if (resp.data.results.products.length) {
            let products = resp.data['results'].products;
            const infoList = [];
            const newProductList = [];
            for (const item of products) {
              if (Boolean(item.stock_comment)) {
                infoList.push({
                  product_fs_id: item.id_fs,
                  name: item.product_name,
                  stock_comment: item.stock_comment
                });
              }

              if (item.id !== null && (item.id.startsWith("N_") || item.id.startsWith("T_"))) {
                newProductList.push({
                  product_fs_id: item.id_fs,
                  name: item.product_name,
                });
              }
            }


            setProductInfoList(infoList)
            setNewProductList(newProductList)

          }

          // console.log("resp ", resp.data['results'].purchase)
          if (resp.data['results'].purchase.length > 0) {
            // resp.data['results'].purchase.sort((a, b) => {
            //   return a.cart_no - b.cart_no
            // })

            resp.data.results.purchase.sort((a, b) =>
              parseDate(a[0]?.order_date) - parseDate(b[0]?.order_date)
            )
            setPurchaseList(resp.data.results.purchase)

          } else {
            setPurchaseMessage("입고 예정인 상품이 없습니다.\n다음에 입고할 상품을 스캔하세요")
          }

          if (resp.data['results'].arrival.length > 0) {
            resp.data['results'].arrival.sort((a, b) =>
              parseDate(a[0]?.recv_date) - parseDate(b[0]?.recv_date)
            )
            console.log('setArrivalList')
            setArrivalList(resp.data['results'].arrival)
          } else {
            setArrivalMessage("입고된 상품이 없습니다.")
          }

        } else if (resp.status === 200 && resp.data != null && resp.data['code'] === 0) {
          history.replace('/signin')
        } else if (resp.status === 200 && resp.data != null && resp.data['code'] === 499) {
          cookie.remove(RECEIVER_COOKIE_KEY)
          history.replace('/not-permitted')
        } else {
          setDialog({
            open: true,
            title: "오류발생",
            message: "데이터를 불러오는데 실패 하였습니다.",
            errorMessage: '에러코드 ' + resp.data != null ? resp.data['code'] : resp.status
          })
        }

        setRequesting(false)

      })
      .catch((e) => {
        console.log('error : ' + e);

        setRequesting(false)
        setDialog({
          open: true,
          title: "오류발생",
          message: "데이터를 불러오는데 실패 하였습니다.",
          errorMessage:
            e.response != null && e.response.status > 0 ?
              "오류코드 : " + e.response.status
              : "네트워크 환경을 확인 해 주세요"
        })
      });
  }

  const setUI = (products) => {
    // setTitle(products[0].name + ' [ ' + products[0].gsheet_rack_code + ' ] ')
    console.log('setUI')
    let ids = []
    for (const product of products) {
      ids.push(product['id_fs'])
    }

    console.log('ids ' + ids.join(','))
    // setProductIds(ids)
    requestPurchase(ids)
  }

  useEffect(() => {
    console.log("arrival ", props)
    // console.log(match.params.id)

    if (props.products && props.products.length > 0 && props.products[0]) {
      console.log("has state ", props.products)
      console.log(props.products)
      setArrivalList([])
      setProducts(props.products)
      setUI(props.products)

    } else {
      setArrivalList([])
      setProducts([])
    }

    return () => {
      console.log('useEffect cleanup')
    }
  }, [props.products])


  const onPassKeyPress = (e, purchase, recv_count, cart) => {
    if (e.key === 'Enter') {
      console.log('onPassKeyPress Enter ', e)
      // checkArrival(purchase, recv_count, cart)
      showExpireDateDialog(purchase, recv_count, cart)
    }
  }

  const renderArrivalList = useMemo(() =>
    <TableContainer style={{ marginTop: 6, minHeight: tableMinHeight }} component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>상품명</TableCell>
            <TableCell align="left">주문날짜</TableCell>
            <TableCell align="left">주문처</TableCell>
            <TableCell align="left">배송지</TableCell>
            <TableCell align="left">주문</TableCell>
            <TableCell align="left">갯수</TableCell>

            <TableCell align="left">위치</TableCell>
            <TableCell align="left">유통기한</TableCell>
            {/*<TableCell align="right">옵션</TableCell>*/}
            {/*<TableCell align="right">위치</TableCell>*/}
            <TableCell align="left">입고위치</TableCell>
            <TableCell align="left">작업자</TableCell>
            <TableCell align="left">입고시간</TableCell>
            <TableCell align="right" />
            <TableCell align="right" />
          </TableRow>
        </TableHead>
        <TableBody>
          {arrivalList
            .map((arrivals, index) => (
              arrivals.map((row, index) => (
                <TableRow
                  key={index}
                >
                  <TableCell component="th" scope="row">
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                      {
                        row.is_related === 'Y' ?
                          <SubdirectoryArrowRightOutlined style={{ color: 'mediumblue', width: 18 }} />
                          :
                          <div />
                      }
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        {
                          row.img_url ?
                            <img
                              onClick={(e) => {
                                e.stopPropagation()
                                setImageShow({
                                  open: true,
                                  url: row.img_url,
                                  title: row.product_name
                                })

                              }}
                              src={changeImageURL(row.img_url)} alt={row.product_name}
                              style={{ ...clickableItem, width: 48, height: 48 }} />
                            :
                            <div style={{ width: 48, height: 48 }} />
                        }
                        <div style={{ marginLeft: 6 }}>{row.product_name}</div>
                      </div>
                    </div>
                  </TableCell>
                  <TableCell align={"left"} component="th" scope="row">
                    {moment(new Date(row.order_date)).format('YYYY/MM/DD HH:mm')}
                  </TableCell>
                  <TableCell align={"left"} component="th" scope="row">
                    {getShopNameString(row.shop_name)}
                  </TableCell>
                  <TableCell align={"left"} component="th" scope="row">
                    {getWarehouseName(row.warehouse, warehouseState)}{row.buy_cond && row.buy_cond.startsWith('집') ? '(집)' : ''}
                  </TableCell>
                  <TableCell align={"left"} component="th" scope="row">
                    {row.buyer_name_list}</TableCell>
                  <TableCell align="left">{row.recv_quantity + '/' + row.buy_quantity}</TableCell>
                  <TableCell align="left">{getRackCodeByCenterId(props.centerId, warehouseState, row.gsheet_rack_code)}</TableCell>
                  <TableCell align="left">
                    {row.expire_date ? moment(new Date(row.expire_date)).format('YYYY/MM') : "-"}
                  </TableCell>
                  <TableCell align="left">{getRecvCenterName(row, warehouseState)}</TableCell>
                  <TableCell align="left">{row.receiver_name}</TableCell>
                  <TableCell align="left">
                    {moment(new Date(row.recv_date)).format('HH:mm')}
                  </TableCell>
                  <TableCell align="right">
                    {/*<ChevronRight/>*/}
                    {
                      row.recv_state !== 'W' ?
                        <Button
                          onClick={() => {
                            // setOpenDeleteDialog(true)
                            // setSelectedPurchase(row)
                            requestCancelArrival(row)
                          }}
                          variant={"contained"} color={"secondary"}>
                          취소
                        </Button>
                        :
                        <div />
                    }
                  </TableCell>
                  <TableCell align={"right"}>
                    <IconButton
                      onClick={() => {
                        getArrivalHistoryAndShowDialog(row, null, false)
                      }}>
                      <MoreVertOutlined fontSize={'small'} />
                    </IconButton>
                  </TableCell>
                </TableRow>

              ))
            ))}
        </TableBody>
      </Table>
    </TableContainer>


    , [arrivalList, requestCancelArrival])

  const getColorByState = (purchase) => {
    if (purchase.recv_state === 'C' && (purchase.recv_quantity === purchase.buy_quantity)) {
      return { backgroundColor: RECEIVE_ALL_CHECKED_COLOR, color: 'white' }
    } else if (purchase.recv_state === 'C' && (purchase.recv_quantity < purchase.buy_quantity)) {
      return { backgroundColor: RECEIVE_PARTIAL_CHECKED_COLOR, }
    }

    return { color: 'grey' }
  }

  // const arrivalHistoryRow = (row, purchase, key) => {
  //   let values = row.event_value.split('/')
  //
  //   let recv_quantity = values[0] || 0;
  //   let recv_state = values[1]
  //   let recv_yn = values[2]
  //   let status_desc = null
  //   let status_bgcolor = null
  //   let status_textcolor = null
  //   if(recv_yn === 'Y'){
  //     status_desc = '입고됨'
  //     status_bgcolor = '#002171'
  //     status_textcolor = 'white'
  //   }else{
  //     if(recv_quantity > 0){
  //       status_desc = `${recv_quantity}/${purchase.buy_quantity}`
  //       if(recv_quantity < purchase.buy_quantity){
  //         status_bgcolor = RECEIVE_PARTIAL_CHECKED_COLOR;
  //       }else{
  //         status_bgcolor = RECEIVE_ALL_CHECKED_COLOR;
  //         status_textcolor = 'white'
  //       }
  //     }else{
  //       status_desc = `입고안됨`
  //       status_bgcolor = 'lightgray'
  //     }
  //   }
  //   //입고 상태 ${recv_state},
  //   let desc = `[${row.center_name}] ${row.user_name}`
  //   return <Box key={key}>
  //     <Box sx={{display : 'flex', flex: 1}}>
  //       <Box sx={{display : 'flex', flex : 1, fontSize : 15,
  //         pl : 1,
  //         alignItems : 'center',
  //         backgroundColor : status_bgcolor, color : status_textcolor}}>
  //         {status_desc}
  //       </Box>
  //       <Box sx={{flex : 1,
  //         pl : 1,pt : 0.5, pb : 0.5,
  //         // borderBottom : 0, borderTop : 0, borderLeft : 1,
  //         // borderRight : 0,
  //         // borderStyle : 'solid', borderColor : 'lightgray'
  //       }}>
  //         <ListItemText primary={desc}
  //                     secondary={moment(new Date(row.create_date)).format('YY년MM월DD일 HH:mm')}/>
  //       </Box>
  //
  //     </Box>
  //
  //   </Box>
  // }

  const renderPurchaseList = useMemo(() =>
    <TableContainer style={{ marginTop: 6, minHeight: tableMinHeight }} component={Paper}>
      <Table size={'medium'}>
        <TableHead>
          <TableRow>
            <TableCell></TableCell>
            <TableCell>상품명</TableCell>
            <TableCell align="left">주문날짜</TableCell>
            <TableCell align="left">주문처</TableCell>
            <TableCell align="left">배송지</TableCell>
            <TableCell align="left">주문자</TableCell>
            <TableCell align="left">입고/주문수</TableCell>
            <TableCell align="left">유통기한</TableCell>
            <TableCell align="left">작업자</TableCell>
            {/*<TableCell align="right">상품코드</TableCell>*/}
            {/*<TableCell align="right">옵션</TableCell>*/}
            <TableCell align="left">위치</TableCell>
            <TableCell align="right"></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {purchaseList.map((purchases, index) =>

            purchases.map((row, index) => (
              <TableRow
                sx={{ "& td": { borderBottom: (purchases.length - 1 === index) ? 0.1 : 0, borderColor: 'lightgray' }, ...clickableItem }}
                hover
                onClick={(e) => {
                  // checkArrival(row, row.buy_quantity, purchases)
                  showExpireDateDialog(row, row.buy_quantity, purchases)
                }}
                key={index}>
                <TableCell
                  style={{ width: 52 }}
                >
                  <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: "center", }}>
                    {
                      row.is_related === 'Y' ?
                        <SubdirectoryArrowRightOutlined style={{ color: 'mediumblue', width: 18 }} />
                        :
                        <div />
                    }
                    {
                      row.img_url ?
                        <img
                          onClick={(e) => {
                            e.stopPropagation()
                            setImageShow({
                              open: true,
                              url: row.img_url,
                              title: row.product_name
                            })
                          }}
                          src={changeImageURL(row.img_url)} alt={row.product_name}
                          style={{ ...clickableItem, width: 48, height: 48 }} />
                        :
                        <div style={{ width: 48, height: 48 }} />
                    }
                  </Box>

                </TableCell>
                <TableCell
                  sx={{ ...getColorByState(row) }}
                  align="left">
                  {row.product_name}
                </TableCell>

                <TableCell
                  sx={{ ...getColorByState(row) }}
                  align="left">
                  {moment(new Date(row.order_date)).format('YYYY/MM/DD HH:mm')}
                </TableCell>
                <TableCell
                  sx={{ ...getColorByState(row) }}
                  align={"left"}
                >
                  {getShopNameString(row.shop_name)}
                </TableCell>
                <TableCell
                  sx={{ ...getColorByState(row) }}
                  align="left">
                  {getWarehouseName(row.warehouse, warehouseState)}{row.buy_cond && row.buy_cond.startsWith('집') ? '(집)' : ''}
                </TableCell>

                <TableCell sx={{ ...getColorByState(row) }}
                  align="left">
                  {row.buyer_name_list}
                </TableCell>
                <TableCell sx={{ ...getColorByState(row) }}
                  onClick={(e) => {

                    getArrivalHistoryAndShowDialog(row, purchases, true)
                    e.stopPropagation()
                    // setCheckDialog({
                    //    ...checkDialog,
                    //    open : true,
                    //    purchase: row,
                    //    cart: purchases,
                    //    recvCount : row.buy_quantity,
                    //    recvCountError : false,
                    //    recvCountHelperText : ''
                    //  })
                  }} align="left">
                  <Box sx={{ display: 'flex', }}>
                    <Box>
                      <MoreVertOutlined fontSize={'small'} />
                    </Box>
                    <Box sx={{ pl: 1, }}>
                      {/*{Boolean(row.recv_quantity) ? `${row.recv_quantity} / ${row.buy_quantity}` : `${row.buy_quantity}`}*/}
                      {`${changeStockValue(row.recv_quantity)} / ${row.buy_quantity}`}
                    </Box>
                  </Box>

                </TableCell>
                <TableCell sx={{ ...getColorByState(row) }} lign="left">
                  {(row.recv_state === 'C' && row.expire_date) ? moment(new Date(row.expire_date)).format('YYYY/MM') : '-'}
                </TableCell>
                <TableCell sx={{ ...getColorByState(row) }}
                  align="left">
                  {(row.recv_state === 'C' && row.last_event_user_name) ? row.last_event_user_name : ''}
                </TableCell>
                {/*<TableCell align="right">{row.product_id}</TableCell>*/}
                {/*<TableCell align="right">{row.product_opt_code}</TableCell>*/}
                <TableCell sx={{ ...getColorByState(row) }}
                  align="left">{getRackCodeByCenterId(props.centerId, warehouseState, row.gsheet_rack_code)}</TableCell>
                <TableCell align="right">
                  <Button
                    disabled={row.recv_state !== 'C'}
                    onClick={(e) => {
                      cancelCheck(row)
                      e.stopPropagation()
                    }}
                    variant={"outlined"} >
                    취소
                  </Button>

                  {/*<IconButton*/}
                  {/*  disabled={row.recv_state !== 'C'}*/}
                  {/*  onClick={() => {*/}
                  {/*    // setDialog({*/}
                  {/*    //   open: true,*/}
                  {/*    //   title: "",*/}
                  {/*    //   message: getEtcList(row.etc_info),*/}
                  {/*    //   errorMessage: ''*/}
                  {/*    // })*/}

                  {/*  }}*/}
                  {/*  style={{padding: 0}}>*/}
                  {/*  <SettingsBackupRestoreRounded/>*/}
                  {/*</IconButton>*/}
                </TableCell>
              </TableRow>
            ))

          )}
        </TableBody>
      </Table>
    </TableContainer>

    , [purchaseList, checkArrival])

  return (
    <Box sx={{
      paddingBottom: (theme) => theme.spacing(1),
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
    }}>

      <FSBarcodeReader
        onRequestStart={() => setRequesting(true)}
        onRequestResults={(results, barcode) => {
          if (results.length > 0) {
            console.log(results[0]['id_fs']);
            setProducts(results)
            setUI(results)
            props.onSelected(results[0])
          } else {
            props.onNewBarcode(barcode)
          }
          setRequesting(false)
        }}
        onRequestError={(error) => {
          setDialog({
            open: true,
            title: '오류',
            message: '바코드인식에 실패 하였습니다.',
            errorMessage: error,
          })
          setRequesting(false)
        }}
      />
      <Box sx={{ width: '100%' }}>
        {
          requesting ?
            <Box
              sx={{
                marginTop: (theme) => theme.spacing(18),
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
              }}>
              <CircularProgress size={34} thickness={4} />
            </Box>
            :
            <div>
              {
                Boolean(products) && products.length > 0 ?
                  <Fragment>
                    {
                      newProductList.map((value, index, array) => (
                        <div>
                          <Alert severity="info">{value.name + ' - 신상품입니다'}</Alert>
                          {/*<Divider/>*/}
                        </div>

                      ))
                    }
                    {
                      productInfoList.map((value, index, array) => (
                        <div>
                          <Alert severity="error">{value.name + ' - ' + value.stock_comment}</Alert>
                          {/*<Divider/>*/}
                        </div>

                      ))
                    }
                    <TableHeaderPaper
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        paddingTop: (theme) => theme.spacing(0),
                        paddingBottom: (theme) => theme.spacing(0),
                        marginTop: (theme) => theme.spacing(1),
                      }}
                      variant={"outlined"}>
                      <Typography variant={"h6"} style={{ marginLeft: 12 }}>입고 예정 상품</Typography>
                      <Box sx={{
                        ml: 2,
                        width: (theme) => theme.spacing(3),
                        height: (theme) => theme.spacing(1.5),
                        // borderRadius : (theme) => theme.spacing(2.5),
                        backgroundColor: RECEIVE_ALL_CHECKED_COLOR,
                        // radius : '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }} />
                      <Box sx={{ ml: 1, }}>모두 확인됨</Box>
                      <Box sx={{
                        ml: 1,
                        width: (theme) => theme.spacing(3),
                        height: (theme) => theme.spacing(1.5),
                        // borderRadius : (theme) => theme.spacing(2.5),
                        backgroundColor: RECEIVE_PARTIAL_CHECKED_COLOR,
                        // radius : '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }} />
                      <Box sx={{ ml: 1, }}>입고수 부족</Box>
                    </TableHeaderPaper>
                    {
                      Boolean(purchaseMessage) ?
                        <MessagePaper
                          variant={"outlined"}>
                          {/*{getMultilineTextToHtml(message)}*/}
                          <div dangerouslySetInnerHTML={{ __html: getMultilineTextToHtml(purchaseMessage) }} />
                        </MessagePaper>
                        :
                        renderPurchaseList

                    }
                    <TableHeaderPaper
                      variant={"outlined"}>
                      <Typography variant={"h6"} style={{ marginLeft: 12 }}>오늘 입고</Typography>
                    </TableHeaderPaper>
                    {
                      Boolean(arrivalMessage) ?
                        <MessagePaper
                          variant={"outlined"}>
                          {/*{getMultilineTextToHtml(message)}*/}
                          <div dangerouslySetInnerHTML={{ __html: getMultilineTextToHtml(arrivalMessage) }} />
                        </MessagePaper>
                        :
                        renderArrivalList
                    }
                  </Fragment>
                  :
                  <Box
                    sx={{
                      paddingTop: (theme) => theme.spacing(28),
                      display: 'flex',
                      width: '100%',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <Typography variant={"body1"}>바코드를 스캔하거나</Typography>
                    <Typography variant={"body1"}>상품을 검색 하세요</Typography>
                  </Box>
              }
            </div>
        }
      </Box>

      <Dialog
        open={dialog.open}
        onClose={() => {
          setDialog({ ...dialog, open: false })
        }}
      >
        <DialogTitle id="alert-dialog-title">{dialog.title}</DialogTitle>

        <DialogContent aria-multiline={true}>
          <div>{dialog.message}</div>
          <div>{dialog.errorMessage}</div>

        </DialogContent>
        <DialogActions>
          <Button onClick={() => { setDialog({ ...dialog, open: false }) }} color="primary">
            닫기
          </Button>
        </DialogActions>
      </Dialog>
      <Backdrop
        style={{
          zIndex: (theme) => theme.zIndex.drawer + 1,
          color: '#fff',
        }}
        open={imageShow.open}
        onClick={() => setImageShow({ ...imageShow, open: false })}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <img src={changeImageURL(imageShow.url)} style={{ width: 320, height: 320 }} />
          <div style={{ marginTop: 10 }}>{imageShow.title}</div>
        </div>
      </Backdrop>
      <Dialog
        id={'check-arrival-dialog'}
        open={checkDialog.open}
        onClose={() => {
          setCheckDialog({
            ...checkDialog,
            open: false,
          })
        }}
      >
        <DialogTitle>입고확인</DialogTitle>

        <DialogContent sx={{
          display: 'flex',
          flexDirection: 'column',
          width: 280,
        }}>
          {purchaseInfoForDialog(checkDialog.purchase)}
          <TextField
            variant={"outlined"}
            InputLabelProps={{
              shrink: true,
            }}
            sx={{ marginTop: 2 }}
            helperText={checkDialog.recvCountHelperText}
            error={checkDialog.recvCountError}
            type={"number"}
            required={true}
            value={checkDialog.recvCount}
            onKeyPress={(e) => onPassKeyPress(e, checkDialog.purchase, checkDialog.recvCount, checkDialog.cart)}
            onChange={changeRecvCount}
            label={"입고갯수"} />

        </DialogContent>
        <DialogActions>
          <Button onClick={() => setCheckDialog({ ...checkDialog, open: false })} color="secondary">
            취소
          </Button>
          <Button autoFocus={true} onClick={() => showExpireDateDialog(checkDialog.purchase, checkDialog.recvCount, checkDialog.cart)} color="primary" disabled={checkDialog.recvCountError}>
            입고
          </Button>
        </DialogActions>
        <DialogContent
          aria-multiline={true}
          sx={{
            minWidth: 280,
            maxHeight: 240,
            p: 1,
            borderWidth: (theme) => theme.spacing(0.1),
            borderColor: 'black',
            borderStyle: 'solid',
          }}
        >
          {
            arrivalHistoryList(checkDialog.history, checkDialog.purchase)
          }
        </DialogContent>
      </Dialog>
      <Dialog
        id={'check-arrival-dialog'}
        open={arrivalHistoryDialog.open}
        onClose={() => {
          setArrivalHistoryDialog({
            ...arrivalHistoryDialog,
            open: false,
          })
        }}
      >
        <DialogTitle>변경 내역</DialogTitle>

        <DialogContent>
          {purchaseInfoForDialog(arrivalHistoryDialog.purchase)}
        </DialogContent>


        <DialogContent
          aria-multiline={true}
          sx={{
            minWidth: 280,
            maxHeight: 240,
            p: 1,
            borderWidth: (theme) => theme.spacing(0.1),
            borderColor: 'black',
            borderStyle: 'solid',
          }}
        >
          {
            arrivalHistoryList(arrivalHistoryDialog.history, arrivalHistoryDialog.purchase)
          }
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setArrivalHistoryDialog({ ...arrivalHistoryDialog, open: false })} color="secondary">
            닫기
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        id={'expiration-date-dialog'}
        fullWidth={true}
        maxWidth={true}
        open={expireDateDialog.open}
        onClose={() => {
          setExpireDateDialog({
            ...expireDateDialog,
            open: false,
          })
        }}
      >
        <DialogTitle>유통기한선택</DialogTitle>
        <DialogContent
          aria-multiline={true}
          sx={{
            // minWidth : 900,
            // maxHeight : 240,
            // p : 1,
          }}
        >
          {
            expireDateDialog.years.map((year) => {
              const now = new Date()
              now.setDate(1)
              now.setHours(0)
              now.setMinutes(0)
              now.setSeconds(0)
              now.setMilliseconds(0)

              return <Box sx={{ display: 'flex', p: 2, fontSize: 20, }}>
                <Box sx={{ display: 'flex', alignItems: 'center', fontSize: 22, fontWeight: 'bold' }}>{year.getFullYear()}</Box>
                <Grid sx={{ ml: 4, }} container spacing={1}>
                  {
                    [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((month) => {
                      const date = new Date(year.getFullYear(), month - 1, 1, 0, 0, 0)
                      const beforeMonth = date.getTime() < now.getTime()
                      // console.log('now ', now, ', date ', date)

                      return <Grid
                        onClick={() => {
                          if (beforeMonth) {
                            return
                          }
                          // setExpireDateDialog({...expireDateDialog, open: false})
                          checkArrival(expireDateDialog.purchase, expireDateDialog.recvCount, expireDateDialog.cart, date)
                        }}
                        item xs={1}>
                        <Box
                          sx={{
                            height: 40,
                            borderWidth: (theme) => theme.spacing(0.1),
                            borderColor: beforeMonth ? '#E0E0E0' : 'black',
                            color: beforeMonth ? '#E0E0E0' : 'black',
                            borderStyle: 'solid',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            // cursor : 'pointer',
                            cursor: beforeMonth ? 'auto' : 'pointer'
                          }}
                        >
                          {month}
                        </Box>
                      </Grid>
                    })
                  }

                </Grid>
              </Box>
            })
          }
        </DialogContent>
        <DialogActions>
          <Button onClick={() => checkArrival(expireDateDialog.purchase, expireDateDialog.recvCount, expireDateDialog.cart, null)} color="info">
            건너뛰기
          </Button>
          <Button onClick={() => setExpireDateDialog({ ...expireDateDialog, open: false })} color="secondary">
            닫기
          </Button>
        </DialogActions>
      </Dialog>
      <Backdrop
        open={showOverlayProgress}
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 1,
          color: '#fff',
        }}>
        <CircularProgress color="inherit" />
      </Backdrop>
      {/*<Snackbar*/}
      {/* open={snackbar.open}*/}
      {/* autoHideDuration={2000}*/}
      {/* onClose={()=>setSnackbar({open : false, message: ''})}*/}
      {/* message={snackbar.message}*/}
      {/* />*/}
    </Box>
  )
}


